/**
 * AgencyBadge — compact agency abbreviation badge for the Command Dashboard.
 *
 * COORD-26: Blue-tinted rounded box with truncated agency name. Theme-aware.
 */
export default function AgencyBadge({ agency, size = "sm" }) {
  if (!agency) return null;

  // Abbreviate long agency names
  const abbr = agency.length > 20 ? agency.slice(0, 18) + "..." : agency;

  const sizeClasses = size === "md"
    ? "text-[10px] px-2 py-0.5"
    : "text-[9px] px-1.5 py-0.5";

  return (
    <span
      className={`inline-flex items-center rounded font-medium whitespace-nowrap bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 ${sizeClasses}`}
    >
      {abbr}
    </span>
  );
}
